// extracted by mini-css-extract-plugin
export default {"logoimg":"SocialIcon_logoimg__FAGfv","logoIcon":"SocialIcon_logoIcon__2eskh","logo-spin":"SocialIcon_logo-spin__5QR1y"};